import React, { useEffect, useState } from 'react';
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, Box } from '@mui/material';

const ParametrosMaquinas = () => {
  const [maquinas, setMaquinas] = useState([]);
  const [parametros, setParametros] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Consulta la lista de máquinas y sus parámetros actuales
    const fetchMaquinas = async () => {
      try {
        const res = await fetch('/api/maquinas-parametros');
        const data = await res.json();
        console.log('Datos recibidos del servidor:', data);
        setMaquinas(data.maquinas);
        setParametros(data.parametros);
        setLoading(false);
      } catch (error) {
        console.error('Error al cargar máquinas:', error);
        setLoading(false);
      }
    };
    fetchMaquinas();
  }, []);

  const handleChange = (maquinaId, param, value) => {
    setParametros(prev => {
      const updated = {
        ...prev,
        [maquinaId]: {
          ...prev[maquinaId],
          maquinaId: maquinaId, // Aseguramos que maquinaId esté presente
          [param]: value === '' ? undefined : Number(value)
        }
      };
      console.log('Parámetros actualizados:', updated);
      return updated;
    });
  };

  // Filtra solo los parámetros con claves tipo ObjectId (MongoDB)
  const getParametrosFiltrados = () => {
    const parametrosFiltrados = {};
    Object.keys(parametros).forEach(key => {
      if (/^[a-f\d]{24}$/i.test(key)) { // Solo ObjectId válidos
        parametrosFiltrados[key] = parametros[key];
      }
    });
    return parametrosFiltrados;
  };

  const handleGuardar = async () => {
    const parametrosFiltrados = getParametrosFiltrados();
    const token = localStorage.getItem('token');
    
    console.log('Guardando parámetros:', parametrosFiltrados);
    
    const response = await fetch('/api/maquinas-parametros', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      body: JSON.stringify({ parametros: parametrosFiltrados })
    });

    if (response.ok) {
      alert('Parámetros guardados correctamente en la base de datos');
      // Emitir evento para que otros componentes se actualicen
      window.dispatchEvent(new Event('parametrosMaquinasActualizados'));
    } else {
      const errorData = await response.json();
      console.error('Error al guardar:', errorData);
      alert('Error al guardar los parámetros: ' + (errorData.message || 'Error desconocido'));
    }
  };

  if (loading) return <div>Cargando...</div>;

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" gutterBottom>
          Parámetros por Máquina
        </Typography>
        {/* <Button component={Link} to="/maquinas/parametros/ingreso" variant="contained">
          Ingreso de Parametros
        </Button> */}
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Máquina</TableCell>
              <TableCell>Temp. mín</TableCell>
              <TableCell>Temp. máx</TableCell>
              <TableCell>Hum. mín</TableCell>
              <TableCell>Hum. máx</TableCell>
              <TableCell>Amp. mín</TableCell>
              <TableCell>Amp. máx</TableCell>
              <TableCell>RPM mín</TableCell>
              <TableCell>RPM máx</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {maquinas.map(m => (
              <TableRow key={m._id}>
                <TableCell>{m.machineNumber || m.nombre || m._id}</TableCell>
                {['minTemp','maxTemp','minHum','maxHum','minAmp','maxAmp','minRpm','maxRpm'].map(param => (
                  <TableCell key={param}>
                    <TextField
                      type="number"
                      value={parametros[m._id]?.[param] ?? ''}
                      onChange={e => handleChange(m._id, param, e.target.value)}
                      size="small"
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={handleGuardar}>
        Guardar parámetros
      </Button>
    </Container>
  );
};

export default ParametrosMaquinas;